import "core-js/modules/web.dom-collections.iterator.js";
import { RemixPage } from "~/utils/remix-page";
import { cssLinks } from "@ttark/css-links";
import { SearchSugHead } from "./head";
import { SearchSugBody } from "./body";
import { buildMasterLoader } from "~/utils/build-master-loader";
var links = () => [...cssLinks("routes/search.sug")];
var loader = buildMasterLoader("searchSug");
var SearchSPage = class extends RemixPage {
  constructor() {
    super(...arguments);
    this.Head = SearchSugHead;
    this.Body = SearchSugBody;
  }
  get page() {
    return "search-sug";
  }
};
var clientLoader = async _ref => {
  let {
    serverLoader
  } = _ref;
  const serverData = await serverLoader();
  return serverData;
};
export { clientLoader, SearchSPage as default, links };